<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.135"
        height="11.695"
        viewBox="0 0 19.135 11.695"
    >
        <g id="Logout" transform="translate(19.135 11.695) rotate(180)">
            <path
                id="Pfad_392"
                data-name="Pfad 392"
                d="M23.864,11.28H11.183a1.141,1.141,0,1,1,0-2.28H23.864a1.141,1.141,0,1,1,0,2.28"
                transform="translate(-10 -4.293)"
                :class="fillClass + ' transition-fill'"
            />
            <path
                id="Pfad_393"
                data-name="Pfad 393"
                d="M17.8,16.835,17.785,6.667a.8.8,0,0,1,1.35-.54l5.278,5.078a.742.742,0,0,1,0,1.078l-5.268,5.09a.793.793,0,0,1-1.348-.538"
                transform="translate(-5.509 -5.903)"
                :class="fillClass + ' transition-fill'"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "BackIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
            default: "fill-white",
        },
    },
});
</script>
